<template>
  <div class="space-y-5 py-5 lg:space-y-6 lg:pt-12">
    <div
      v-if="!ambitions?.length"
      class="heading-sub"
      v-bind="$attrs"
    >
      {{ $t('No ambitions found') }}.
    </div>

    <div
      v-for="ambition in ambitions"
      v-else
      :key="ambition.id"
    >
      <AmbitionBlock
        :ambition="ambition"
        class="lg:even:grid-content-rtl"
        :style="{backgroundColor: ambition.color ?? ambition.parent?.color}"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type {AmbitionsQuery} from '~/graphql/graphql';

defineProps<{
  ambitions: NonNullable<AmbitionsQuery['ambitions']>,
}>();

const localePath = useLocalePath();
</script>
